// Español — Spanish translation. Mirrors the keys in en.js.

const es = {
  "nav.simulator": "Simulador",
  "nav.rules": "Reglas",
  "brand.tagline": "Simulador de Ingresos",

  "landing.eyebrow": "Simulador de ingresos en vivo",
  "landing.title.pre": "Modela tus",
  "landing.title.highlight": "comisiones",
  "landing.title.post": "de U.CENTER en tiempo real.",
  "landing.subtitle": "Proyección interactiva usando las reglas de Initial Ripple, Ripple Wave, Deep Ripple y Drop Match de u.center/docs. Configura tu equipo y observa cómo se actualizan los cálculos al instante.",
  "landing.cta.primary": "Abrir el simulador",
  "landing.cta.secondary": "Ver las reglas",

  "sim.eyebrow": "Simulador de ingresos en vivo",
  "sim.title.pre": "Construye tu equipo.",
  "sim.title.highlight": "Descubre cuánto ganas.",
  "sim.subtitle": "Construye tu organización nivel por nivel. Cada paso añade matemáticas reales — las comisiones y acciones se actualizan en cuanto configuras la siguiente capa. Reglas de",
  "sim.reset": "Reiniciar",
  "sim.share": "Compartir",

  "step.1.title": "Tu paquete inicial",
  "step.1.sub": "Define tu rango inicial y desbloquea los niveles de Initial Ripple.",
  "step.1.done": "{pkg} · ${price} · Empieza en {rank}",
  "step.2.title": "Tus reclutas de Nivel 1",
  "step.2.sub": "Las personas que traes personalmente.",
  "step.2.question": "¿A cuántas personas reclutarás personalmente?",
  "step.2.avgPkg": "Paquete promedio que comprarán tus directos",
  "step.2.done": "{count} directos con {pkg} · ${vol} vol",
  "step.level.title": "Equipo de Nivel {n}",
  "step.level.sub": "Reclutas hechos por cada miembro de Nivel {parent}.",
  "step.level.question": "En promedio, ¿a cuántas personas recluta cada miembro de Nivel {parent}?",
  "step.level.avgPkg": "Paquete promedio para miembros de Nivel {n}",
  "step.level.done": "{ratio}/miembro de Nivel {parent} → {count} con {pkg} · ${vol} vol",
  "step.summary.volume": "Nivel {n} · {count} miembros",
  "step.summary.volumeShort": "Volumen del Nivel 1",
  "step.next": "Siguiente: Nivel {n} →",
  "step.finish": "Añadir niveles más profundos (opcional) →",
  "step.of": "Paso {n} de {total}",
  "step.edit": "Editar",

  "hero.projection": "Proyección a tu profundidad configurada",
  "hero.youEarn": "Tú ganas",
  "hero.commissionsSub": "en comisiones ({pct}% del volumen de la organización)",
  "hero.teamGenerates": "Tu equipo genera",
  "hero.teamGeneratesSub": "volumen total de la organización",
  "hero.teamPayout": "Pagos al equipo",
  "hero.teamPayoutSub": "comisiones pagadas a todo tu equipo",
  "hero.plusShares": "más acciones",
  "hero.plusSharesSub": "{start} iniciales + {earned} vía Drop Match",
  "hero.teamSize": "Tamaño del equipo",
  "hero.teamSizeSub": "miembros activos",
  "hero.yourRank": "Tu rango",
  "hero.perMember": "$ / miembro",
  "hero.perMemberSub": "comisión promedio",
  "hero.avgOrder": "Pedido promedio",
  "hero.avgOrderSub": "en todo tu equipo",
  "hero.next": "Siguiente: {rank} · {unlock}",
  "hero.qvToGo": "faltan {qv} QV",

  "empty.title": "Elige tu paquete para empezar",
  "empty.sub": "Tus comisiones proyectadas, acciones y rango aparecerán aquí mientras construyes tu escenario paso a paso.",

  "chart.title": "Ingresos vs tamaño del equipo",
  "chart.sub": "Cómo crecen tus comisiones a medida que se llena tu organización",
  "chart.footer": "{members} miembros · {vol} vol",

  "bonus.ir.title": "Initial Ripple",
  "bonus.ir.subtitle": "Comisiones directas · L1-L5 · {unlocked}/5 desbloqueados",
  "bonus.ir.footer": "El paquete desbloquea {maxFromPkg}/5. Sube de rango para desbloquear más.",
  "bonus.ir.rowMembers": "{count} miembros · {vol} vol",
  "bonus.ir.rowLocked": "Bloqueado — necesitas {rank}",
  "bonus.ir.rowPotential": "~{amount} pot.",
  "bonus.rw.title": "Ripple Wave",
  "bonus.rw.subtitle": "Comisiones de rango R6+ · {unlocked}/6 niveles desbloqueados",
  "bonus.rw.footer": "1% por nivel desbloqueado en cada pedido de tu línea descendente (L1–L11). Máximo 3 pagos por pedido compartidos con Initial Ripple.",
  "bonus.rw.rowFires": "Aplica sobre {vol} de volumen descendente",
  "bonus.rw.rowCapped": "Desbloqueado — limitado ahora por la regla de 3 pagos",
  "bonus.rw.rowLocked": "Bloqueado — alcanza {rank}",
  "bonus.rw.tag": "Se desbloquea en {rank} · 1% por pedido descendente",
  "bonus.dr.title": "Deep Ripple",
  "bonus.dr.subtitle": "Override de liderazgo · L12-L20 · requiere R12+",
  "bonus.dr.g1": "G1 · R12–R14 (0.3/0.6/0.9%)",
  "bonus.dr.g1sub": "Liderazgo inicial",
  "bonus.dr.g2": "G2 · R15–R17 (0.3/0.6/0.9%)",
  "bonus.dr.g2sub": "Liderazgo avanzado",
  "bonus.dr.g3": "G3 · R18–R20 (0.3/0.6/0.9%)",
  "bonus.dr.g3sub": "Liderazgo élite",
  "bonus.dr.footer": "Tasa = posición dentro de tu grupo. Solo aplica cuando el tope de 3 pagos tiene espacio.",
  "bonus.dm.title": "Drop Match",
  "bonus.dm.subtitle": "Acciones (no efectivo) · L1-L3 · sin tope",
  "bonus.dm.row": "{count} miembros",
  "bonus.dm.footer": "Drop Match paga acciones (puntos) de U.CENTER, no USD. Sin tope y separado de la regla de 3 pagos.",
  "bonus.dm.total": "{shares} acciones",

  "share.eyebrow": "Escenario compartible",
  "share.title": "Envía esta proyección a un prospecto",
  "share.desc": "Cada dato — paquete, conteos por nivel, modo profundo — va incrustado en la URL. Sin registro, sin vencimiento.",
  "share.linkLabel": "Enlace para compartir",
  "share.copy": "Copiar",
  "share.copied": "Copiado",
  "share.footer": "Cualquiera que abra este enlace verá el escenario exacto que construiste — con todos los cálculos recomputados en su dispositivo.",
  "share.toast.copied.title": "Enlace copiado",
  "share.toast.copied.desc": "Pégalo donde quieras — el escenario viaja con la URL.",
  "share.toast.noPkg.title": "Elige primero un paquete",
  "share.toast.noPkg.desc": "Cuando construyas un escenario, podrás compartirlo.",
  "share.toast.loaded.title": "Escenario cargado desde el enlace",
  "share.toast.loaded.desc": "Todos los datos han sido restaurados. Puedes ajustarlos libremente.",
  "share.snapshot.youEarn": "Tú ganas",
  "share.snapshot.teamPayout": "Pagos al equipo",
  "share.snapshot.rank": "Rango",

  "lang.select": "Idioma",
};

export default es;
